export default {
  'common.empty': ' ',
  'common.ok': 'Đồng ý',
  'common.action': 'Hành động',
  'common.save': 'Lưu',
  'common.cancel': 'Hủy',
  'common.home': 'Trang chủ',
  'common.display': 'Hiển thị',
  'common.entries': 'nội dung trong mỗi trang',
  'common.form.required': 'Vui lòng nhập',
  'common.delete': 'Xóa',
  'common.share': 'Chia sẻ',
  'common.listen': 'Nghe',
  'common.statusActive': 'Khả dụng',
  'common.add': 'Thêm',
  'common.addSchool': 'Đăng ký trường',
  'common.edit': 'Cập nhật',
  'common.all': 'Tất cả',
  'common.keyword': 'Từ khóa',
  'common.statusDeactive': 'Không khả dụng',
  'common.button.accept': 'Xác nhận',
  'common.button.resend.link': 'Gửi lại link',
  'common.button.return': 'Quay lại',
  'common.button.continue': 'Tiếp theo',
  'common.button.complete': 'Hoàn tất',
  'link.return.login': 'Quay lại trang đăng nhập',
  'common.answers': 'Danh sách đáp án',
  'common.valid.required': 'Vui lòng điền',
  'common.valid.whitespace': 'Vui lòng không nhập khoảng trắng',
  'common.valid.email': 'Phải đúng định dạng',
  'common.deviceType': 'Loại thiết bị',
  'common.email': 'Địa chỉ email',
  'common.update.user': 'Chỉnh sửa hố sơ',
  'common.update.change-password': 'Thay đổi mật khẩu',
  'common.yes': 'Đồng ý',
  'common.download': 'Tải xuống',
  'common.cancelNews': 'Hủy bản tin',
  'common.logOut': 'Đăng xuất',
  'common.profile': 'Trang cá nhân',
  'common.forgotPassword': 'Quên mật khẩu',
  'common.volumn': 'Điều chỉnh âm lượng',
  'common.powerOn': 'Mở nguồn',
  'common.powerOff': 'Tắt nguồn',
  'common.refresh': 'Khởi động lại',
  'common.update': 'Cập nhật',
  'common.continue': 'Tiếp tục',
  'common.management': 'Quản lý',
  'common.formNote': 'Là trường thông tin bắt buộc',
  'common.active': 'Khả dụng',
  'common.deactive': 'Không khả dụng',
  'common.status': 'Trạng thái',
  'common.statusNotApproval': 'Chưa duyệt',
  'common.statusReject': 'Từ chối',
  'common.invalid': 'không đúng định dạng.',
  'common.input.placeholder': 'Vui lòng nhập {label}',
  'common.status.param':
    '{status,select, 0 {Chưa phê duyệt} 1 {Đã phê duyệt} 2 {Từ chối} other {Không xác định}}',
  'common.status.new': 'Chưa phê duyệt',
  'common.status.approval': 'Đã phê duyệt',
  'common.approval': 'Phê duyệt',
  'common.file-back': 'Thu hồi',
  'common.back': 'Quay lại',
  'common.statusConnect': 'Đang kết nối',
  'common.statusDisconnect': 'Mất kết nối',
  'common.StatusNewsletterPlaying': 'Đang phát bản tin',
  'common.StatusNewsletterStop': 'Dừng phát bản tin',
  'common.goBack': 'Trở Về',
  'common.required.password': 'Vui lòng nhập mật khẩu',
  'common.info': 'Thông tin',
  'dashboard.area': 'Địa bàn',
  'dashboard.radio_device': 'Thiết bị phát thanh',
  'dashboard.mtc_device': 'Thiết bị điện tử công cộng',
  'dashboard.audio_news': 'Bản tin phát thanh',
  'dashboard.mtc_news': 'Bản tin công cộng',
  'area.placeholder': 'Vui lòng nhập tên địa bàn',
  'common.remove': 'Xóa',
  'common.play': 'Phát',
  'common.no.': 'STT',
  'common.stt': 'STT',
  'common.detail': 'Chi tiết',
  'common.non.title': 'Hành động',
  'common.turnOn': 'Bật',
  'common.turnOff': 'Tắt',
  'common.pause': 'Dừng phát',
  'common.convert': 'Chuyển đổi',
  'common.using': 'Đang sử dụng',
  'common.notUse': 'Chưa sử dụng',
  'common.check': 'Lưu',
  'common.close': 'Đóng',
  'common.noti': 'Thông báo',
  'common.viewPlus': 'Xem thêm',
  'common.return': 'Quay lại',
  'common.search.placeholder': 'Nhập từ khóa để tìm kiếm',
  'common.eye': 'Hiển thị',
  'common.eyeOff': 'Ẩn',
  'common.hidden': 'Không hiển thị',
  'common.in.process': 'Đang tải lên',
  'common.logout': 'Đăng xuất',
  'common.logout.title': 'Xác nhận đăng xuất khỏi thiết bị',
  'common.logout.content': 'Bạn có thực sự muốn đăng xuất không?',
  'common.change.password': 'Đổi mật khẩu',
  'common.report': 'Báo cáo',
  'common.page': 'Trang',
  'common.search': 'Tìm kiếm',
  'common.transactions': 'Kiểm kê',
  'common.product': 'Sản phẩm',
  'common.today': 'Hôm nay',
  'common.file': 'Xuất file',
  'common.checkAll': 'Chọn tất cả',
  'common.check-in': 'Đã checkin',
  'common.not-check-in': 'Chưa checkin',
  'common.LifeBuoy': 'Nhật ký checkin',
  'common.total': 'Tổng tiền',
  'common.month': 'tháng',
  'common.month2': 'Tháng',
  'common.day': 'ngày',
  'common.file-edit': 'Package extension',
  'common.upload': 'Chọn file',
  'common.file-check-green': 'Duyệt',
  'common.file-check-red': 'Từ chối duyệt',
  'common.minus': 'Xóa',
  'common.preview': 'Trình chiếu',
  'common.403error': 'Lỗi 403',
  'common.permission.notfound': 'Bạn không có quyền truy cập',
  'common.403note':
    'Bạn đang chưa được phân quyền cho hệ thống này vui lòng liên hệ admin để được hỗ trợ.',
  'common.selected': '{rows} nội dung đã được chọn',
  'common.confirm': 'Xác nhận',
  'common.volume': 'Âm lượng',
  'common.qr': 'Mã QR',
  'common.upgrade': 'Nâng cấp',
  'common.backToSystem': 'Trở về hệ thống quản lý ',
  'common.pay': 'Thanh toán',
  'common.pickOther': 'Chọn gói khác',
  'common.control': 'Điều khiển',
  'common.operationStatus': 'Trạng thái hoạt động',
  'common.unlimited': 'Không thời hạn',
  'common.year': 'năm',
  'common.usedPackage': 'Gói cước sử dụng',
  'common.InActive': 'Không khả dụng',
  'common.Used': 'Đang sử dụng',
  'common.linkError': 'Rất tiếc, liên kết không hợp lệ.',
  'common.notPlay': 'Xin lỗi, hệ thống hiện chưa hỗ trợ phát loại media này.',
  'common.notImplementedYet': 'Tính năng đang phát tiển',
  'common.qrCode': 'Mã qr',
  'common.renew': 'Thanh toán lại',
  'common-required-phone-country': 'Số điện thoại phải từ 5 đến 15 ký tự!',
  'common.plus.square': 'Tạo bản sao',
  'common.startTime': 'Giờ bắt đầu',
  'common.endTime': 'Giờ kết thúc',
  'common.startDate': 'Ngày bắt đầu',
  'common.endDate': 'Ngày kết thúc',
  'common.screenshot.his': 'Lịch sử hình chụp',
  'common.accessExpired.title': 'Hết hạn quyền truy cập',
  'common.accessExpired.message':
    'Giấy phép sử dụng của hệ thống đã hết hạn. Vui lòng liên hệ quản trị viên để được hỗ trợ gia hạn.',
};
